import type { PostHog } from 'posthog-js'
import type { UserProfile } from './useUser'

function getPostHog(): PostHog | null {
  if (!import.meta.client) return null
  const { $clientPosthog } = useNuxtApp()
  return ($clientPosthog as PostHog | null) ?? null
}

export function useAnalytics() {
  const identify = (userData?: UserProfile | null) => {
    const posthog = getPostHog()
    if (!posthog) return

    const u = userData ?? null
    if (!u) return

    posthog.identify(u.id, {
      email: u.email,
      name: u.name,
      role: u.role,
      isPremium: u.isPremium,
      clinicCount: u.clinics.length,
      subscriptionStatus: u.subscription?.status ?? null,
      billingInterval: u.subscription?.billingInterval ?? null,
    })
  }

  const reset = () => {
    const posthog = getPostHog()
    if (!posthog) return
    posthog.reset()
  }

  const capture = (eventName: string, properties?: Record<string, unknown>) => {
    const posthog = getPostHog()
    if (!posthog) return
    posthog.capture(eventName, properties)
  }

  return { identify, reset, capture }
}
